import { FormInstance } from "antd";
import { CustomForm } from "../../Form/index.styled";
import { RadioGroupForm } from "./Form/RadioGroup";

interface UserInfoServiceBrakePadFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
}

/**
 * 브레이크패드
 * @param param0
 * @returns
 */
export const UserInfoServiceBrakePadForm: React.FC<
  UserInfoServiceBrakePadFormProps
> = ({ readonly = false }) => {
  return (
    <CustomForm.Item>
      <RadioGroupForm
        name={[
          "repairShopOption",
          "options",
          "services",
          "brakepad",
          "isActivated",
        ]}
        rules={[
          {
            required: true,
          },
        ]}
        readonly={readonly}
      />
    </CustomForm.Item>
  );
};
